import { useState } from "react";

export type CmtsAuditFilters = Record<string, string>;

export function CmtsAuditFilterPanel(props: { readonly onChange?: ((filters: CmtsAuditFilters) => void) | undefined }) {
  const [filters, setFilters] = useState<CmtsAuditFilters>({});
  function update(key: string, value: string) {
    const next = { ...filters, [key]: value };
    if (!value.trim()) delete next[key];
    setFilters(next);
    props.onChange?.(next);
  }
  return (
    <section className="cmts-audit-filter-panel" aria-label="Audit filters">
      <label>Search <input value={filters.search ?? ""} onChange={(event) => update("search", event.currentTarget.value)} /></label>
      <label>Entity <input value={filters.entityType ?? ""} onChange={(event) => update("entityType", event.currentTarget.value)} /></label>
      <label>Correlation <input value={filters.correlationId ?? ""} onChange={(event) => update("correlationId", event.currentTarget.value)} /></label>
    </section>
  );
}
